import React, { useState } from 'react';
import { toast } from 'react-toastify';

import Header from '~/Components/Header/Header';
import { buscarFechamentoCaixa } from '~/Services/Service';

import SecaoFiltros from './components/SecaoFiltros';
import SecaoMovimentos from './components/SecaoMovimentos';
import SecaoConferencia from './components/SecaoConferencia';

const extrairMensagemErro = (err, fallback) => {
  if (err && typeof err === 'object' && err.message) return err.message;
  return fallback;
};

const ESTADO_INICIAL = {
  filtros: null,
  movimentos: [],
  valoresIniciaisCurrency: null,
  calculo: null,
  statusFluxo: 'filtros',
};

const FechamentoCaixa = () => {
  const [filtros, setFiltros] = useState(ESTADO_INICIAL.filtros);
  const [movimentos, setMovimentos] = useState(ESTADO_INICIAL.movimentos);
  const [valoresIniciaisCurrency, setValoresIniciaisCurrency] = useState(
    ESTADO_INICIAL.valoresIniciaisCurrency
  );
  const [calculo, setCalculo] = useState(ESTADO_INICIAL.calculo);
  const [statusFluxo, setStatusFluxo] = useState(ESTADO_INICIAL.statusFluxo);
  const [buscando, setBuscando] = useState(false);

  const resetarTela = () => {
    setFiltros(null);
    setMovimentos([]);
    setValoresIniciaisCurrency(null);
    setCalculo(null);
    setStatusFluxo('filtros');
  };

  const handleBuscar = (filtrosForm) => {
    setBuscando(true);
    const payload = {
      codigo_grupo_empresa: filtrosForm.codigo_grupo_empresa,
      codigo_conta: filtrosForm.codigo_conta,
      codigo_ativo: filtrosForm.codigo_ativo,
      dt_inicial: filtrosForm.dt_inicial,
    };
    buscarFechamentoCaixa(payload)
      .then((res) => {
        const lista = res && Array.isArray(res.movimentos) ? res.movimentos : [];
        setFiltros(filtrosForm);
        setMovimentos(lista);

        const iniciais =
          res &&
          (res.dinheiro != null ||
            res.moeda != null ||
            res.vale != null ||
            res.cheque != null)
            ? {
                dinheiro: Number(res.dinheiro || 0),
                moeda: Number(res.moeda || 0),
                vale: Number(res.vale || 0),
                cheque: Number(res.cheque || 0),
              }
            : null;
        setValoresIniciaisCurrency(iniciais);

        setCalculo(null);
        setStatusFluxo('movimentos');
      })
      .catch((err) => {
        toast.error(
          extrairMensagemErro(err, 'Erro ao buscar movimentações do período')
        );
      })
      .finally(() => {
        setBuscando(false);
      });
  };

  const handleCalculadoSucesso = (resultado) => {
    setCalculo(resultado);
    setStatusFluxo('conferencia');
  };

  const handleCancelado = () => {
    resetarTela();
  };

  const handleLancadoSucesso = () => {
    resetarTela();
  };

  const handleConflict = () => {
    resetarTela();
  };

  return (
    <div>
      <Header title="Fechamento de Caixa" />

      <div className="container-fluid py-3">
        <SecaoFiltros
          onBuscar={handleBuscar}
          buscando={buscando}
          disabled={statusFluxo !== 'filtros'}
          valoresIniciais={filtros}
        />

        {(statusFluxo === 'movimentos' || statusFluxo === 'conferencia') &&
          filtros && (
            <SecaoMovimentos
              filtros={filtros}
              movimentos={movimentos}
              valoresIniciais={valoresIniciaisCurrency}
              onCalculadoSucesso={handleCalculadoSucesso}
              onCancelado={handleCancelado}
              carregando={false}
            />
          )}

        {statusFluxo === 'conferencia' && filtros && calculo && (
          <SecaoConferencia
            filtros={filtros}
            calculo={calculo}
            onLancadoSucesso={handleLancadoSucesso}
            onConflict={handleConflict}
          />
        )}
      </div>
    </div>
  );
};

export default FechamentoCaixa;
